import axiosInstance from '../axiosInstance';

const BASE_ROUTE = '/notifications';

const ENDPOINTS = {
  notifications: BASE_ROUTE,
  updateNotificationStatus: id => `${BASE_ROUTE}/${id}/status`,
  markAllAsRead: () => `${BASE_ROUTE}/mark-all-as-read`,
  notificationsSettings: () => `${BASE_ROUTE}/configs`,
  entityDeletionDecision: id => `${BASE_ROUTE}/${id}/entity-deletion-decision`,
  caseDeletionDecision: id => `${BASE_ROUTE}/${id}/case-deletion-decision`,
  notifyUsers: () => `${BASE_ROUTE}/notify`,
  reassign: () => `${BASE_ROUTE}/reassign`,
};

const fetchNotifications = params => {
  return axiosInstance.get(ENDPOINTS.notifications, { params });
};

const updateNotificationStatus = ({ id, notificationStatus }) => {
  return axiosInstance.put(ENDPOINTS.updateNotificationStatus(id), { notificationStatus });
};

const markAllAsRead = () => {
  return axiosInstance.put(ENDPOINTS.markAllAsRead());
};

const fetchNotificationsSettings = () => {
  return axiosInstance.get(ENDPOINTS.notificationsSettings());
};

const updateNotificationsSettings = data => {
  return axiosInstance.put(ENDPOINTS.notificationsSettings(), data);
};

const caseDeletionDecision = (id, data) => {
  return axiosInstance.put(ENDPOINTS.caseDeletionDecision(id), data);
};

const entityDeletionDecision = (id, data) => {
  return axiosInstance.put(ENDPOINTS.entityDeletionDecision(id), data);
};

const notifyUsers = data => {
  return axiosInstance.post(ENDPOINTS.notifyUsers(), data);
};

const reassign = data => {
  return axiosInstance.post(ENDPOINTS.reassign(), data);
};

export default {
  fetchNotifications,
  updateNotificationStatus,
  markAllAsRead,
  fetchNotificationsSettings,
  updateNotificationsSettings,
  caseDeletionDecision,
  entityDeletionDecision,
  notifyUsers,
  reassign,
};
